import { OnBoardingIcons } from "../Assets/images/image";
import Phase1Applications from "../Components/OnBoarding/Phase1Applications";
import SubmittedMobileApplications from "../Components/OnBoarding/SubmittedMobileApp";
import SubmittedRoutingPayin from "../Components/OnBoarding/PayinRoutingSubmitted";
import PayoutSubmitted from "../Components/OnBoarding/PayoutSubmitted";
import SubmittedRoutingEkyc from "../Components/OnBoarding/EkycRoutingSubmitted";
import MDRSubmittedAccountApplications from "../Components/OnBoarding/MDRSubmitted";
import FRMSubmitted from "../Components/OnBoarding/FRMSubmitted";

export const OnBoardingRegistry = [
    {
        label: "Applications",
        key: "Phase1Applications",
        // requiredSub: "Application phase 1 view",
        requiredSub: ["Application phase 1 view", "Application phase 2 view"],
        component: Phase1Applications,
        icon: OnBoardingIcons.Application,
    },
    {
        label: "Mobile App On-Boarding",
        key: "MobileAppOnboardingSubmitted",
        requiredSub: "Mobile App Applications",
        component: SubmittedMobileApplications,
        icon: OnBoardingIcons.mobileAppOnboard,
    },
    {
        label: "Payin Routing",
        key: "SubmittedRoutingPayin",
        requiredSub: "Payin Routing View",
        component: SubmittedRoutingPayin,
        icon: OnBoardingIcons.payinrouting,
    },
    {
        label: "Payout Routing",
        key: "PayoutSubmitted",
        requiredSub: "Payout Routing View",
        component: PayoutSubmitted,
        icon: OnBoardingIcons.payout,
    },
    {
        label: "e-kYC Routing",
        key: "SubmittedRoutingEkyc",
        requiredSub: "E kyc Routing View",
        component: SubmittedRoutingEkyc,
        icon: OnBoardingIcons.ekyc,
    },
    {
        label: "MDR",
        key: "MDRSubmittedAccountApplications",
        requiredSub: "MDR View",
        component: MDRSubmittedAccountApplications,
        icon: OnBoardingIcons.voucher,
    },
    {
        label: "Fraud & Risk Management",
        key: "FRMSubmitted",
        requiredSub: "FRM View",
        component: FRMSubmitted,
        icon: OnBoardingIcons.trap,
    },
];